import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = [{
  title: 'El Manual Maestro (PDF)',
  desc: 'La guía paso a paso para desmantelar tu armadura y reconstruir tu magnetismo.'
}, {
  title: 'La Fórmula 3-2-1',
  desc: 'La secuencia exacta de contacto visual que detiene el pensamiento lógico de un hombre y activa su instinto de persecución.'
}, {
  title: 'El Ángulo de 45°',
  desc: 'Cómo posicionar tu cuerpo para ser un desafío irresistible en lugar de una confrontación.'
}, {
  title: 'Checklist de Salida',
  desc: "6 puntos clave para revisar antes de entrar a cualquier lugar y asegurar que tu señal está en 'Atracción Máxima'."
}, {
  title: 'Auditoría de Postura',
  desc: "Ejercicios prácticos para eliminar los tics de 'Mujer Ocupada' que bloquean tu flujo femenino."
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="py-24 px-6 bg-darker" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-161">
          <h2 className="font-serif text-3xl md:text-4xl text-cream" data-id="element-162">
            ¿Qué Incluye el Sistema?
          </h2>
          <div className="w-24 h-px bg-gold mx-auto mt-6 opacity-50" data-id="element-163"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid gap-4" data-id="element-164">
          {items.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-5 bg-dark/50 p-6 md:p-8 rounded-sm border border-gold/10 hover:border-gold/30 transition-colors duration-300" data-id="element-165">
              <div className="mt-1 flex-shrink-0 text-gold" data-id="element-166">
                <Check className="w-6 h-6" data-id="element-167" />
              </div>
              <div data-id="element-168">
                <h3 className="font-serif text-xl text-gold mb-2" data-id="element-169">
                  {item.title}
                </h3>
                <p className="font-sans text-cream/80 font-light leading-relaxed" data-id="element-170">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}